import { Col, Flex, message, Row } from "antd";
import { RuleFormCard } from "./components/RuleFormCard";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Rule } from "@rumble-it/common-lib/types/models/Rule.interface";
import {
  fetchRuleById,
  updateRuleById,
} from "../../../lib/api/resources/rules";
import { useNavigate, useParams } from "react-router-dom";

export const RuleEdit = () => {
  const { id } = useParams();

  if (!id) return null;
  const navigate = useNavigate();

  const ruleQuery = useQuery({
    queryKey: ["rule", id],
    queryFn: () => fetchRuleById(id),
  });

  const updateRuleMutation = useMutation({
    mutationFn: (data: Rule) => updateRuleById(id, data),
    onSuccess: () => {
      navigate(`/rules/${id}`);
      message.success("Regel succesvol bijgewerkt");
    },
    onError: () =>
      message.error("Er is een fout opgetreden bij het bijwerken van de regel"),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <RuleFormCard
              loading={ruleQuery.isLoading}
              initialValues={ruleQuery.data}
              mutation={updateRuleMutation}
              title="Rule bijwerken"
              buttonText="Bijwerken"
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
